webpackJsonp([1],{

/***/ "/lGl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0Pog":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "206e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B3XJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JD12":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LeDW":
/***/ (function(module, exports) {

module.exports = {"feat4pos":{"*":{"prc0":{"options":["0","Al_det","lA_neg","mA_neg","mA_part","mA_rel"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_conj","fa_rc","fa_sub","wa_conj","wa_part","wa_sub"],"required":true},"prc1":{"options":["0","bi_part","bi_prep","fiy_prep","hA_dem","ka_prep","la_prep","la_rc","li_jus","li_prep","sa_fut","ta_prep","wA_voc","wa_prep","yA_voc"],"required":true},"gen":{"options":["f","m","u"],"required":false},"num":{"options":["d","p","s","u"],"required":false},"stt":{"options":["c","d","i","u"],"required":false},"cas":{"options":["a","g","n"],"required":false},"enc0":{"options":["0","1p_dobj","1p_poss","1p_pron","1s_poss","1s_dobj","1s_pron","2d_poss","2d_pron","2d_dobj","2fp_dobj","2fp_poss","2fp_pron","2fs_dobj","2fs_poss","2fs_pron","2ms_dobj","2ms_poss","2ms_pron","2mp_dobj","2mp_poss","2mp_pron","3d_dobj","3d_poss","3d_pron","3fp_dobj","3fp_poss","3fp_pron","3fs_dobj","3fs_poss","3fs_pron","3mp_dobj","3mp_poss","3mp_pron","3ms_dobj","3ms_poss","3ms_pron","Ah_voc","lA_neg","mA_interrog","mA_rel","mA_sub","ma_interrog","ma_sub","ma_rel","man_interrog","man_rel"],"required":true},"vox":{"options":["a","u"],"required":false},"asp":{"options":["c","i","p"],"required":false},"rat":{"options":["i","r","u"],"required":false},"per":{"options":["1","2","3"],"required":false},"mod":{"options":["i","j","u"],"required":false},"form_gen":{"options":["f","m"],"required":false},"form_num":{"options":["d","p","u"],"required":false}},"noun":{"prc0":{"options":["0","Al_det","mA_part","mA_neg","mA_rel","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true},"gen":{"options":["m","f"],"required":false},"num":{"options":["s","d","p","u"],"required":false},"stt":{"options":["i","d","c","u"],"required":false},"cas":{"options":["n","a","g","u"],"required":false},"enc0":{"options":["0","3mp_poss","2mp_poss","3ms_poss","2fp_poss","1s_poss","1p_poss","2fs_poss","3d_poss","3fp_poss","2d_poss","3fs_poss","2ms_poss"],"required":true}},"noun_num":{"prc0":{"options":["0","Al_det","mA_part","mA_neg","mA_rel","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true},"gen":{"options":["m","f"],"required":false},"num":{"options":["s","d","p","u"],"required":false},"stt":{"options":["i","d","c","u"],"required":false},"cas":{"options":["n","a","g","u"],"required":false},"enc0":{"options":["0","3mp_poss","2mp_poss","3ms_poss","2fp_poss","1s_poss","1p_poss","2fs_poss","3d_poss","3fp_poss","2d_poss","3fs_poss","2ms_poss"],"required":true}},"noun_quant":{"prc0":{"options":["0","Al_det","mA_part","mA_neg","mA_rel","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true},"gen":{"options":["m","f"],"required":false},"num":{"options":["s","d","p","u"],"required":false},"stt":{"options":["i","d","c","u"],"required":false},"cas":{"options":["n","a","g","u"],"required":false},"enc0":{"options":["0","3mp_poss","2mp_poss","3ms_poss","2fp_poss","1s_poss","1p_poss","2fs_poss","3d_poss","3fp_poss","2d_poss","3fs_poss","2ms_poss"],"required":true}},"noun_prop":{"prc0":{"options":["0","Al_det","mA_part","mA_neg","mA_rel","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true},"gen":{"options":["m","f"],"required":false},"num":{"options":["s","d","p","u"],"required":false},"stt":{"options":["i","d","c","u"],"required":false},"cas":{"options":["n","a","g","u"],"required":false},"enc0":{"options":["0","3mp_poss","2mp_poss","3ms_poss","2fp_poss","1s_poss","1p_poss","2fs_poss","3d_poss","3fp_poss","2d_poss","3fs_poss","2ms_poss"],"required":true}},"adj":{"prc0":{"options":["0","Al_det","mA_part","mA_neg","mA_rel","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true},"gen":{"options":["m","f"],"required":false},"num":{"options":["s","d","p","u"],"required":false},"stt":{"options":["i","d","c","u"],"required":false},"cas":{"options":["n","a","g","u"],"required":false},"enc0":{"options":["0","3mp_poss","2mp_poss","3ms_poss","2fp_poss","1s_poss","1p_poss","2fs_poss","3d_poss","3fp_poss","2d_poss","3fs_poss","2ms_poss"],"required":true}},"adj_num":{"prc0":{"options":["0","Al_det","mA_part","mA_neg","mA_rel","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true},"gen":{"options":["m","f"],"required":false},"num":{"options":["s","d","p","u"],"required":false},"stt":{"options":["i","d","c","u"],"required":false},"cas":{"options":["n","a","g","u"],"required":false},"enc0":{"options":["0","3mp_poss","2mp_poss","3ms_poss","2fp_poss","1s_poss","1p_poss","2fs_poss","3d_poss","3fp_poss","2d_poss","3fs_poss","2ms_poss"],"required":true}},"adj_comp":{"prc0":{"options":["0","Al_det","mA_part","mA_neg","mA_rel","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true},"gen":{"options":["m","f"],"required":false},"num":{"options":["s","d","p","u"],"required":false},"stt":{"options":["i","d","c","u"],"required":false},"cas":{"options":["n","a","g","u"],"required":false},"enc0":{"options":["0","3mp_poss","2mp_poss","3ms_poss","2fp_poss","1s_poss","1p_poss","2fs_poss","3d_poss","3fp_poss","2d_poss","3fs_poss","2ms_poss"],"required":true}},"verb":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true},"gen":{"options":["m","f","u"],"required":false},"num":{"options":["s","d","p","u"],"required":false},"vox":{"options":["a","p","u"],"required":false},"asp":{"options":["c","i","p"],"required":false},"per":{"options":["1","2","3"],"required":false},"mod":{"options":["i","j","s","u"],"required":false},"enc0":{"options":["0","3d_dobj","3mp_dobj","1s_dobj","3fs_dobj","2d_dobj","2mp_dobj","3ms_dobj","2fp_dobj","3fp_dobj","2fs_dobj","1p_dobj","2ms_dobj"],"required":true}},"prep":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true},"enc0":{"options":["0","3d_pron","3ms_pron","3mp_pron","2d_pron","2fp_pron","2ms_pron","2mp_pron","2fs_pron","3fp_pron","1s_pron","3fs_pron","1p_pron"],"required":true}},"verb_pseudo":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true},"enc0":{"options":["0","3d_pron","3ms_pron","3mp_pron","2d_pron","2fp_pron","2ms_pron","2mp_pron","2fs_pron","3fp_pron","1s_pron","3fs_pron","1p_pron"],"required":true}},"part_det":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true}},"part":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true}},"part_restrict":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true}},"part_interrog":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true}},"part_voc":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true}},"part_focus":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true}},"conj":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true}},"part_verb":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true}},"conj_sub":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true}},"part_fut":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true}},"part_neg":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","la_emph","li_jus","la_rc","sa_fut"],"required":true}},"pron_dem":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true},"gen":{"options":["m","f"],"required":false},"num":{"options":["s","d","p","u"],"required":false}},"pron_rel":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true},"gen":{"options":["m","f"],"required":false},"num":{"options":["s","d","p","u"],"required":false}},"pron":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true},"gen":{"options":["m","f"],"required":false},"num":{"options":["s","d","p","u"],"required":false}},"pron_interrog":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true}},"adv":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true}},"adv_interrog":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true}},"adv_rel":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true}},"pron_exclam":{"prc0":{"options":["0","mA_part","mA_neg","lA_neg"],"required":true},"prc3":{"options":["0",">a_ques"],"required":true},"prc2":{"options":["0","fa_rc","fa_sub","fa_conj","fa_conn","wa_part","wa_sub","wa_conj"],"required":true},"prc1":{"options":["0","ka_prep","li_prep","bi_prep","la_prep","fiy_prep","wa_prep","bi_part","hA_dem","wA_voc","yA_voc","la_emph","la_rc"],"required":true}}}}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/font-awesome/css/font-awesome.min.css
var font_awesome_min = __webpack_require__("e0XP");
var font_awesome_min_default = /*#__PURE__*/__webpack_require__.n(font_awesome_min);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-resource/dist/vue-resource.esm.js
var vue_resource_esm = __webpack_require__("8+8L");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {
      navIsActive: false
    };
  },

  methods: {
    toggleNavBar: function toggleNavBar(val) {
      if (val === null || val === undefined) {
        this.navIsActive = !this.navIsActive;
      } else {
        this.navIsActive = val;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-790e81db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav',{staticClass:"navbar is-fixed-top",attrs:{"id":"main-nav"}},[_c('div',{staticClass:"navbar-brand"},[_c('div',{staticClass:"navbar-burger burger",class:{ 'is-active': _vm.navIsActive},attrs:{"data-target":"mainNavbar"},on:{"click":function($event){return _vm.toggleNavBar()}}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])]),_vm._v(" "),_c('div',{staticClass:"navbar-menu",class:{ 'is-active': _vm.navIsActive},attrs:{"id":"mainNavbar"}},[_c('div',{staticClass:"navbar-start"},[_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/analyzer"},nativeOn:{"click":function($event){return _vm.toggleNavBar(false)}}},[_vm._v("\n          Analyzer\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/generator"},nativeOn:{"click":function($event){return _vm.toggleNavBar(false)}}},[_vm._v("\n          Generator\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/reinflector"},nativeOn:{"click":function($event){return _vm.toggleNavBar(false)}}},[_vm._v("\n          Reinflector\n        ")])],1)])]),_vm._v(" "),_c('router-view'),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-item"},[_c('a',{attrs:{"href":"https://nyuad.nyu.edu/en/research/centers-labs-and-projects/computational-approaches-to-modeling-language-lab.html","target":"_blank"}},[_c('img',{staticClass:"footer-logo footer-logo-camel",attrs:{"src":"/static/camel.png"}})])]),_vm._v(" "),_c('div',{staticClass:"level-item"},[_c('a',{attrs:{"href":"https://nyuad.nyu.edu","target":"_blank"}},[_c('img',{staticClass:"footer-logo",attrs:{"src":"/static/nyuad.png"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("206e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/AnalyzerOutput.vue
var AnalyzerOutput = __webpack_require__("THkH");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2675d638","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/AnalyzerOutput.vue
var AnalyzerOutput_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analyzer-output"},[_c('div',{staticClass:"ambiguity-total has-text-info"},[_vm._v("\n    Ambiguity = [Lemma: "+_vm._s(_vm.ambigFormat(_vm.sortedTranslatedOutput.ambiguity.lemmas))+" | Analysis: "+_vm._s(_vm.ambigFormat(_vm.sortedTranslatedOutput.ambiguity.analyses))+"]\n  ")]),_vm._v(" "),_vm._l((_vm.sortedTranslatedOutput.words),function(word,index){return _c('div',{key:index,staticClass:"analysis-container collapsible"},[_c('div',{staticClass:"word collapse-header"},[_c('a',{staticClass:"has-text-primary collapse-btn"}),_vm._v(" "),_c('span',{attrs:{"dir":"rtl"}},[_vm._v(_vm._s(word.word))]),_vm._v(" "),_c('span',{staticClass:"ambiguity-word has-text-info"},[_vm._v("Ambiguity = [Lemma: "+_vm._s(_vm.ambigFormat(word.ambiguity.lemmas))+" | Analysis: "+_vm._s(_vm.ambigFormat(word.ambiguity.analyses))+"]")])]),_vm._v(" "),_c('div',{staticClass:"collapse-body"},[(Object.keys(word.lemmas).length === 0)?_c('div',{staticClass:"lemma-group collapsible"},[_c('div',{staticClass:"lemma collapse-header"}),_vm._v(" "),_c('div',{staticClass:"collapse-body"},[_vm._v("\n          No Analysis\n        ")])]):_vm._e(),_vm._v(" "),_vm._l((word.sortedLemmas),function(lemma,index){return (Object.keys(word.lemmas).length > 0)?_c('div',{key:index,staticClass:"lemma-group collapsible"},[_c('div',{staticClass:"lemma collapse-header"},[_c('a',{staticClass:"has-text-primary collapse-btn"}),_vm._v(" "),_vm._l((lemma.split(' ')),function(sublemma,index){return _c('span',{key:index},[(index === 0)?_c('span',{attrs:{"dir":"rtl"}},[_vm._v(_vm._s(sublemma))]):_vm._e(),_vm._v(" "),(index > 0)?_c('span',[_vm._v(_vm._s(sublemma))]):_vm._e()])}),_vm._v(" "),_c('span',[_vm._v(" — "+_vm._s(word.lemmas[lemma].glossString)+" ")])],2),_vm._v(" "),_c('div',{staticClass:"collapse-body"},[(_vm.rawView)?_c('table',{staticClass:"analyses table"},[_c('tbody',_vm._l((word.lemmas[lemma].raw),function(analysis,index){return _c('tr',{key:'a-' + index,staticClass:"analysis"},_vm._l((_vm.featOrder),function(feat,index){return _c('td',{key:index,staticClass:"feat-val"},[_c('span',{staticClass:"feat"},[_vm._v(_vm._s(feat)+":")]),_vm._v(" "),(_vm.tokFeats[feat] == 1)?_c('span',{staticClass:"val",attrs:{"dir":"rtl"}},_vm._l(([_vm.parseToks(analysis[feat])]),function(tokfeats,index){return _c('span',{key:'t-' + index},[_vm._l((tokfeats.prefixes),function(prefix,index){return _c('span',{key:'p-' + index,attrs:{"dir":"rtl"}},[_c('span',{attrs:{"dir":"rtl"}},[_vm._v(_vm._s(prefix))]),_c('span',{attrs:{"dir":"rtl"}},[_vm._v("+_")])])}),_vm._v(" "),_vm._l((tokfeats.stems),function(stem,index){return _c('span',{key:'s-' + index,attrs:{"dir":"rtl"}},[_c('span',{attrs:{"dir":"rtl"}},[_vm._v(_vm._s(stem))])])}),_vm._v(" "),_vm._l((tokfeats.suffixes),function(suffix,index){return _c('span',{key:'u-' + index,attrs:{"dir":"rtl"}},[_c('span',{attrs:{"dir":"rtl"}},[_vm._v("_+")]),_c('span',{attrs:{"dir":"rtl"}},[_vm._v(_vm._s(suffix))])])})],2)}),0):(feat == 'lex')?_c('span',{staticClass:"val"},[_vm._v(_vm._s(analysis.lex.split(/_|-/)[0]))]):_c('span',{staticClass:"val",attrs:{"dir":_vm.ltrFeats[feat] ? 'ltr' : 'rtl'}},[_vm._v(_vm._s((feat == 'caphi' && analysis.source === 'backoff') ? '*' : analysis[feat]))])])}),0)}),0)]):_vm._e(),_vm._v(" "),(!_vm.rawView)?_c('table',{staticClass:"analyses table"},[_c('tbody',_vm._l((word.lemmas[lemma].translated),function(analysis,index){return _c('tr',{key:'a' + index,staticClass:"analysis"},[_c('td',{staticClass:"feat-val simple",attrs:{"dir":"rtl"}},[_c('b',[_vm._v(_vm._s(analysis.diac))])]),_vm._v(" "),_c('td',{staticClass:"feat-val simple"},[(analysis.source === 'backoff')?_c('i',[_vm._v("N/A")]):_vm._e(),_vm._v(" "),(analysis.source !== 'backoff')?_c('i',[_vm._v(_vm._s(analysis.caphi))]):_vm._e()]),_vm._v(" "),_vm._l((analysis.prc),function(prc,index){return (prc && prc.lex && prc.pos)?_c('td',{key:'p' + index,staticClass:"feat-val simple"},[_c('span',{attrs:{"dir":"rtl"}},[_vm._v(_vm._s(prc.lex))]),_vm._v("/"),_c('span',[_vm._v(_vm._s(prc.pos))])]):_vm._e()}),_vm._v(" "),_c('td',{staticClass:"feat-val simple"},[(analysis.morphoFeat && analysis.morphoFeat.length)?_c('span',[_vm._v("["+_vm._s(analysis.morphoFeat)+"]")]):_vm._e()]),_vm._v(" "),_vm._l((analysis.enc),function(enc,index){return (enc && enc.lex && enc.pos)?_c('td',{key:'e' + index,staticClass:"feat-val simple"},[_c('span',{attrs:{"dir":"rtl"}},[_vm._v(_vm._s(enc.lex))]),_vm._v("/"),_c('span',[_vm._v(_vm._s(enc.pos))])]):_vm._e()})],2)}),0)]):_vm._e()])]):_vm._e()})],2)])})],2)}
var AnalyzerOutput_staticRenderFns = []
var AnalyzerOutput_esExports = { render: AnalyzerOutput_render, staticRenderFns: AnalyzerOutput_staticRenderFns }
/* harmony default export */ var Shared_AnalyzerOutput = (AnalyzerOutput_esExports);
// CONCATENATED MODULE: ./src/components/Shared/AnalyzerOutput.vue
function AnalyzerOutput_injectStyle (ssrContext) {
  __webpack_require__("0Pog")
}
var AnalyzerOutput_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AnalyzerOutput___vue_template_functional__ = false
/* styles */
var AnalyzerOutput___vue_styles__ = AnalyzerOutput_injectStyle
/* scopeId */
var AnalyzerOutput___vue_scopeId__ = "data-v-2675d638"
/* moduleIdentifier (server only) */
var AnalyzerOutput___vue_module_identifier__ = null
var AnalyzerOutput_Component = AnalyzerOutput_normalizeComponent(
  AnalyzerOutput["a" /* default */],
  Shared_AnalyzerOutput,
  AnalyzerOutput___vue_template_functional__,
  AnalyzerOutput___vue_styles__,
  AnalyzerOutput___vue_scopeId__,
  AnalyzerOutput___vue_module_identifier__
)

/* harmony default export */ var components_Shared_AnalyzerOutput = (AnalyzerOutput_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Analyzer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Analyzer = ({
  name: 'Analyzer',
  components: {
    AnalyzerOutput: components_Shared_AnalyzerOutput
  },
  data: function data() {
    return {
      inputText: '',
      backoff: 'NONE',
      match: 'ALL',
      output: null,
      rawView: false,
      lang: 'en',
      errorMsg: 'An error occurred during analysis.',
      showError: false
    };
  },


  methods: {
    analyze: function analyze() {
      var _this = this;

      this.output = null;
      this.showError = false;

      this.inputText = this.inputText.trim();

      if (this.inputText.length === 0) {
        // TODO: throw an error
        return;
      }

      this.$http.get('/api' + '/analyze/?sent=' + encodeURIComponent(this.inputText) + '&backoff=' + encodeURIComponent(this.backoff) + '&match=' + encodeURIComponent(this.match)).then(function (response) {
        _this.output = response.body;
      }).catch(function (error) {
        _this.showError = true;
        // eslint-disable-next-line
        console.log(error);
      });
    },
    setRawView: function setRawView(v) {
      this.rawView = v;
    }
  },

  watch: {},

  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09a2f5e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Analyzer.vue
var Analyzer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("CALIMA Star Analyzer")]),_vm._v(" "),_c('div',{attrs:{"id":"analyzer-input"}},[_vm._m(0),_vm._v(" "),_c('form',{on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.analyze.apply(null, arguments)}}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-full"},[_c('label',{staticClass:"label"},[_vm._v("Input")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputText),expression:"inputText"}],staticClass:"input ar-input",attrs:{"dir":"rtl","lang":"ar","type":"text","placeholder":"Write a word or sentence to analyze"},domProps:{"value":(_vm.inputText)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.inputText=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-two-fifths"},[_c('label',{staticClass:"label"},[_vm._v("Backoff Mode")]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.backoff),expression:"backoff"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.backoff=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"NONE"}},[_vm._v("No Backoff")]),_vm._v(" "),_c('option',{attrs:{"value":"ADD_ALL"}},[_vm._v("Backoff to all POS")]),_vm._v(" "),_c('option',{attrs:{"value":"ADD_PROP"}},[_vm._v("Backoff to Proper Nouns")])])])]),_vm._v(" "),_c('div',{staticClass:"column is-one-fifth is-flex"},[_c('a',{staticClass:"button is-primary is-fullwidth align-bottom",on:{"click":_vm.analyze}},[_vm._v("Analyze")])])])])]),_vm._v(" "),(_vm.showError)?_c('div',{staticClass:"error-box has-text-danger is-size-5"},[_c('p'),_c('div',{staticClass:"fa fa-times"}),_vm._v(" "+_vm._s(_vm.errorMsg)),_c('p')]):_vm._e(),_vm._v(" "),(_vm.output !== null)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.output !== null)?_c('div',{attrs:{"id":"analyzer-output"}},[_c('label',{staticClass:"label"},[_vm._v("Output")]),_vm._v(" "),_c('div',{staticClass:"output-control"},[(!_vm.rawView)?_c('a',{staticClass:"has-text-primary",on:{"click":function($event){return _vm.setRawView(true)}}},[_vm._v("Show Feature-Value Pairs")]):_vm._e(),_vm._v(" "),(_vm.rawView)?_c('a',{staticClass:"has-text-primary",on:{"click":function($event){return _vm.setRawView(false)}}},[_vm._v("Show Simplified Analyses")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box analysis-wrapper"},[_c('analyzer-output',{attrs:{"lang":_vm.lang,"outputData":_vm.output,"rawView":_vm.rawView}})],1)]):_vm._e(),_vm._v(" "),_vm._m(1)])}
var Analyzer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification is-primary"},[_c('p',[_c('strong',[_vm._v("CALIMA Star")]),_vm._v(" is an Arabic morphological analyzer and generator.\n        The analyzer mode determines all the possible out-of-context  combinations of lemmas, morphological features, and diacritizations for undiacritized surface words.\n        This demo is based on the work described in Taji et al. (2018). "),_c('sup',[_vm._v("[1]")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bibliography"},[_c('p',[_vm._v("[1]\n      "),_c('a',{attrs:{"href":"/static/CalimaStar.pdf","target":"_blank"}},[_vm._v("\n        Dima Taji, Salam Khalifa, Ossama Obeid, Fadhl Eryani and Nizar Habash.\n        "),_c('strong',[_vm._v("An Arabic Morphological Analyzer and Generator with Copious Features.")]),_vm._v(" "),_c('i',[_vm._v("Workshop on Computational Research in Phonetics, Phonology, and Morphology.\n        The Confernece on Empirical Methods in Natural Language Processing (EMNLP 2018), Brussels, Belgium.")])])])])}]
var Analyzer_esExports = { render: Analyzer_render, staticRenderFns: Analyzer_staticRenderFns }
/* harmony default export */ var components_Analyzer = (Analyzer_esExports);
// CONCATENATED MODULE: ./src/components/Analyzer.vue
function Analyzer_injectStyle (ssrContext) {
  __webpack_require__("B3XJ")
}
var Analyzer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Analyzer___vue_template_functional__ = false
/* styles */
var Analyzer___vue_styles__ = Analyzer_injectStyle
/* scopeId */
var Analyzer___vue_scopeId__ = "data-v-09a2f5e4"
/* moduleIdentifier (server only) */
var Analyzer___vue_module_identifier__ = null
var Analyzer_Component = Analyzer_normalizeComponent(
  Analyzer,
  components_Analyzer,
  Analyzer___vue_template_functional__,
  Analyzer___vue_styles__,
  Analyzer___vue_scopeId__,
  Analyzer___vue_module_identifier__
)

/* harmony default export */ var src_components_Analyzer = (Analyzer_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./src/components/Shared/genFeats.json
var genFeats = __webpack_require__("LeDW");
var genFeats_default = /*#__PURE__*/__webpack_require__.n(genFeats);

// EXTERNAL MODULE: ./src/components/Shared/translations.json
var translations = __webpack_require__("eBIA");
var translations_default = /*#__PURE__*/__webpack_require__.n(translations);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Generator.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Generator = ({
  name: 'Generator',
  components: {
    AnalyzerOutput: components_Shared_AnalyzerOutput
  },
  data: function data() {
    var feats = {};
    var featList = ['prc3', 'prc2', 'prc1', 'prc0', 'enc0', 'per', 'gen', 'num', 'cas', 'stt', 'vox', 'mod', 'asp'];
    var posListSorted = lodash_default.a.sortBy(keys_default()(genFeats["feat4pos"]));
    var pos = posListSorted[1];

    featList.sort();

    for (var i = 0; i < featList.length; i += 1) {
      var feat = featList[i];
      var featProps = {
        selected: false
      };

      if (genFeats["feat4pos"][pos][feat]) {
        var featVal = genFeats["feat4pos"][pos][feat].required ? genFeats["feat4pos"][pos][feat].options[0] : '*';
        featProps.value = featVal;
      }

      feats[feat] = featProps;
    }

    return {
      lemma: '',
      pos: pos,
      posList: posListSorted,
      feats: feats,
      lang: 'en',
      errorMsg: 'An error occurred during generation.',
      showError: false,
      translations: translations["translations"],
      featList: featList,
      feat4pos: genFeats["feat4pos"],
      output: null,
      selectedFeat: null,
      rawView: false,
      cliticFeats: ['prc3', 'prc2', 'prc1', 'prc0', 'enc0'],
      otherFeats1: ['per', 'gen', 'num', 'cas'],
      otherFeats2: ['stt', 'vox', 'mod', 'asp'],
      lodash: lodash_default.a
    };
  },


  watch: {
    pos: function pos(newPOS, oldPOS) {
      for (var i = 0; i < this.featList.length; i += 1) {
        var feat = this.featList[i];
        if (genFeats["feat4pos"][newPOS][feat]) {
          var tmpFeatVal = this.cliticFeats.includes(feat) ? '0' : '*';
          var featVal = genFeats["feat4pos"][oldPOS][feat] && genFeats["feat4pos"][newPOS][feat].options.includes(this.feats[feat].value) ? this.feats[feat].value : tmpFeatVal;
          this.feats[feat].value = featVal;
        }
      }
    }
  },

  methods: {
    generate: function generate() {
      var _this = this;

      this.output = null;
      this.showError = false;

      var lemma = this.lemma.trim();

      if (lemma === '' || lemma.split(/\s/).length !== 1) {
        // TODO: Throw error
        return;
      }

      var featBuffer = ['lemma=' + encodeURIComponent(this.lemma), 'pos=' + encodeURIComponent(this.pos)];

      for (var i = 0; i < this.featList.length; i += 1) {
        var feat = this.featList[i];
        if (this.feat4pos[this.pos] && this.feat4pos[this.pos][feat] && this.feats[feat].value !== '*' && this.feats[feat].value !== '0') {
          var featVal = this.feats[feat].value;
          featBuffer.push(encodeURIComponent(feat) + '=' + encodeURIComponent(featVal));
        }
      }

      this.$http.get('/api' + '/generate/?' + featBuffer.join('&')).then(function (response) {
        _this.output = response.body;
      }).catch(function (error) {
        _this.showError = true;
        // eslint-disable-next-line
        console.log(error);
      });
    },
    setRawView: function setRawView(v) {
      this.rawView = v;
    }
  },

  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37aa096a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Generator.vue
var Generator_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("CALIMA Star Generator")]),_vm._v(" "),_c('div',{attrs:{"id":"analyzer-input"}},[_vm._m(0),_vm._v(" "),_c('form',{on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.generate.apply(null, arguments)}}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-fifth"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.translations.feats['lex'][_vm.lang]))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lemma),expression:"lemma"}],staticClass:"input ar-input",attrs:{"dir":"rtl","lang":"ar","type":"text","placeholder":""},domProps:{"value":(_vm.lemma)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.lemma=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column is-one-fifth"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.translations.feats['pos'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pos),expression:"pos"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.pos=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.posList),function(pos){return (pos !== '*')?_c('option',{key:pos,domProps:{"value":pos}},[_vm._v(_vm._s(pos)+"   ("+_vm._s(_vm.translations.pos[pos][_vm.lang])+")")]):_vm._e()}),0)])])]),_vm._v(" "),_c('div',{staticClass:"columns"},_vm._l((_vm.cliticFeats),function(feat){return _c('div',{key:feat,staticClass:"column is-one-fifth"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.translations.feats[feat][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[(_vm.feat4pos[_vm.pos] && _vm.feat4pos[_vm.pos][feat])?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.feats[feat].value),expression:"feats[feat].value"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.feats[feat], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.lodash.sortBy(_vm.feat4pos[_vm.pos][feat].options)),function(val){return (_vm.feat4pos[_vm.pos] && _vm.feat4pos[_vm.pos][feat])?_c('option',{key:val,domProps:{"value":val}},[_vm._v(_vm._s(_vm.translations.feats[feat].values[val][_vm.lang]))]):_vm._e()}),0):_c('select',{attrs:{"disabled":""}})])])}),0),_vm._v(" "),_c('div',{staticClass:"columns"},_vm._l((_vm.otherFeats1),function(feat){return _c('div',{key:feat,staticClass:"column is-one-fifth"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.translations.feats[feat][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[(_vm.feat4pos[_vm.pos] && _vm.feat4pos[_vm.pos][feat])?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.feats[feat].value),expression:"feats[feat].value"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.feats[feat], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.feat4pos[_vm.pos][feat].required)?_c('option',{attrs:{"value":"*"}},[_vm._v("Any")]):_vm._e(),_vm._v(" "),_vm._l((_vm.feat4pos[_vm.pos][feat].options),function(val){return (_vm.feat4pos[_vm.pos] && _vm.feat4pos[_vm.pos][feat])?_c('option',{key:val,domProps:{"value":val}},[_vm._v(_vm._s(_vm.translations.feats[feat].values[val][_vm.lang]))]):_vm._e()})],2):_c('select',{attrs:{"disabled":""}})])])}),0),_vm._v(" "),_c('div',{staticClass:"columns"},_vm._l((_vm.otherFeats2),function(feat){return _c('div',{key:feat,staticClass:"column is-one-fifth"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.translations.feats[feat][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[(_vm.feat4pos[_vm.pos] && _vm.feat4pos[_vm.pos][feat])?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.feats[feat].value),expression:"feats[feat].value"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.feats[feat], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.feat4pos[_vm.pos][feat].required)?_c('option',{attrs:{"value":"*"}},[_vm._v("Any")]):_vm._e(),_vm._v(" "),_vm._l((_vm.feat4pos[_vm.pos][feat].options),function(val){return (_vm.feat4pos[_vm.pos] && _vm.feat4pos[_vm.pos][feat])?_c('option',{key:val,domProps:{"value":val}},[_vm._v(_vm._s(_vm.translations.feats[feat].values[val][_vm.lang]))]):_vm._e()})],2):_c('select',{attrs:{"disabled":""}})])])}),0),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-fifth is-flex"},[_c('a',{staticClass:"button is-primary is-fullwidth align-bottom",on:{"click":_vm.generate}},[_vm._v("Generate")])])])])]),_vm._v(" "),(_vm.showError)?_c('div',{staticClass:"error-box has-text-danger is-size-5"},[_c('p'),_c('div',{staticClass:"fa fa-times"}),_vm._v(" "+_vm._s(_vm.errorMsg)),_c('p')]):_vm._e(),_vm._v(" "),(_vm.output !== null)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.output !== null)?_c('div',{attrs:{"id":"analyzer-output"}},[_c('label',{staticClass:"label"},[_vm._v("Output")]),_vm._v(" "),_c('div',{staticClass:"output-control"},[(!_vm.rawView)?_c('a',{staticClass:"has-text-primary",on:{"click":function($event){return _vm.setRawView(true)}}},[_vm._v("Show Feature-Value Pairs")]):_vm._e(),_vm._v(" "),(_vm.rawView)?_c('a',{staticClass:"has-text-primary",on:{"click":function($event){return _vm.setRawView(false)}}},[_vm._v("Show Simplified Analyses")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box analysis-wrapper"},[_c('analyzer-output',{attrs:{"lang":_vm.lang,"outputData":_vm.output,"rawView":_vm.rawView}})],1)]):_vm._e(),_vm._v(" "),_vm._m(1)])}
var Generator_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification is-primary"},[_c('p',[_c('strong',[_vm._v("CALIMA Star")]),_vm._v(" is an Arabic morphological analyzer and generator.\n        The generator mode generates all the possible inflections of a given lemma, part-of-speech and any desired subset set of morphological features.\n        This demo is based on the work described in Taji et al. (2018). "),_c('sup',[_vm._v("[1]")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bibliography"},[_c('p',[_vm._v("[1]\n      "),_c('a',{attrs:{"href":"/static/CalimaStar.pdf","target":"_blank"}},[_vm._v("\n        Dima Taji, Salam Khalifa, Ossama Obeid, Fadhl Eryani and Nizar Habash.\n        "),_c('strong',[_vm._v("An Arabic Morphological Analyzer and Generator with Copious Features.")]),_vm._v(" "),_c('i',[_vm._v("Workshop on Computational Research in Phonetics, Phonology, and Morphology.\n        The Confernece on Empirical Methods in Natural Language Processing (EMNLP 2018), Brussels, Belgium.")])])])])}]
var Generator_esExports = { render: Generator_render, staticRenderFns: Generator_staticRenderFns }
/* harmony default export */ var components_Generator = (Generator_esExports);
// CONCATENATED MODULE: ./src/components/Generator.vue
function Generator_injectStyle (ssrContext) {
  __webpack_require__("p+Bj")
}
var Generator_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Generator___vue_template_functional__ = false
/* styles */
var Generator___vue_styles__ = Generator_injectStyle
/* scopeId */
var Generator___vue_scopeId__ = "data-v-37aa096a"
/* moduleIdentifier (server only) */
var Generator___vue_module_identifier__ = null
var Generator_Component = Generator_normalizeComponent(
  Generator,
  components_Generator,
  Generator___vue_template_functional__,
  Generator___vue_styles__,
  Generator___vue_scopeId__,
  Generator___vue_module_identifier__
)

/* harmony default export */ var src_components_Generator = (Generator_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reinflector.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Reinflector = ({
  name: 'Reinflector',
  components: {
    AnalyzerOutput: components_Shared_AnalyzerOutput
  },
  data: function data() {
    var feats = {};
    // const featList = Object.keys(featVals);
    var featList = ['prc3', 'prc2', 'prc1', 'prc0', 'enc0', 'per', 'gen', 'num', 'cas', 'stt', 'vox', 'mod', 'asp'];
    var posListSorted = lodash_default.a.sortBy(keys_default()(genFeats["feat4pos"]));
    var pos = posListSorted[1];

    featList.sort();

    for (var i = 0; i < featList.length; i += 1) {
      var feat = featList[i];
      var featProps = {
        selected: false
      };

      if (genFeats["feat4pos"][pos][feat]) {
        var featVal = genFeats["feat4pos"][pos][feat].required ? genFeats["feat4pos"][pos][feat].options[0] : '*';
        featProps.value = featVal;
      }

      feats[feat] = featProps;
    }

    return {
      lemma: '',
      word: '',
      pos: pos,
      posList: posListSorted,
      feats: feats,
      lang: 'en',
      errorMsg: 'An error occurred during reinflection.',
      showError: false,
      translations: translations["translations"],
      featList: featList,
      feat4pos: genFeats["feat4pos"],
      output: null,
      selectedFeat: null,
      rawView: false,
      cliticFeats: ['prc3', 'prc2', 'prc1', 'prc0', 'enc0'],
      otherFeats1: ['per', 'gen', 'num', 'cas'],
      otherFeats2: ['stt', 'vox', 'mod', 'asp'],
      lodash: lodash_default.a
    };
  },


  watch: {
    pos: function pos(newPOS, oldPOS) {
      for (var i = 0; i < this.featList.length; i += 1) {
        var feat = this.featList[i];
        if (genFeats["feat4pos"][newPOS][feat]) {
          var tmpFeatVal = this.cliticFeats.includes(feat) ? '0' : '*';
          var featVal = genFeats["feat4pos"][oldPOS][feat] && genFeats["feat4pos"][newPOS][feat].options.includes(this.feats[feat].value) ? this.feats[feat].value : tmpFeatVal;
          this.feats[feat].value = featVal;
        }
      }
    }
  },

  methods: {
    reinflect: function reinflect() {
      var _this = this;

      this.output = null;
      this.showError = false;

      var word = this.word.trim();

      if (word.length === 0 || word.split(/\s/).length !== 1) {
        // TODO: Throw an error
        return;
      }

      var featBuffer = ['word=' + encodeURIComponent(this.word)];

      var lemma = this.lemma.trim();
      if (lemma.length !== 0) {
        featBuffer.push('lex=' + encodeURIComponent(lemma));
      }

      if (this.pos !== '*') {
        featBuffer.push('pos=' + encodeURIComponent(this.pos));
      }

      for (var i = 0; i < this.featList.length; i += 1) {
        var feat = this.featList[i];
        if (this.feat4pos[this.pos] && this.feat4pos[this.pos][feat] && this.feats[feat].value !== '*' && this.feats[feat].value !== '0') {
          var featVal = this.feats[feat].value;
          featBuffer.push(encodeURIComponent(feat) + '=' + encodeURIComponent(featVal));
        }
      }

      this.$http.get('/api' + '/reinflect/?' + featBuffer.join('&')).then(function (response) {
        _this.output = response.body;
      }).catch(function (error) {
        _this.showError = true;
        // eslint-disable-next-line
        console.log(error);
      });
    },
    setRawView: function setRawView(v) {
      this.rawView = v;
    }
  },

  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d3b8be6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reinflector.vue
var Reinflector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("CALIMA Star Reinflector")]),_vm._v(" "),_c('div',{attrs:{"id":"analyzer-input"}},[_vm._m(0),_vm._v(" "),_c('form',{on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.reinflect.apply(null, arguments)}}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-fifth"},[_c('label',{staticClass:"label"},[_vm._v("Word")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.word),expression:"word"}],staticClass:"input ar-input",attrs:{"dir":"rtl","lang":"ar","type":"text","placeholder":""},domProps:{"value":(_vm.word)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.word=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column is-one-fifth"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.translations.feats['lex'][_vm.lang]))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lemma),expression:"lemma"}],staticClass:"input ar-input",attrs:{"dir":"rtl","lang":"ar","type":"text","placeholder":""},domProps:{"value":(_vm.lemma)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.lemma=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column is-one-fifth"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.translations.feats['pos'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pos),expression:"pos"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.pos=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.posList),function(pos){return (pos != '*')?_c('option',{key:pos,domProps:{"value":pos}},[_vm._v(_vm._s(pos)+"   ("+_vm._s(_vm.translations.pos[pos][_vm.lang])+")")]):_vm._e()}),0)])])]),_vm._v(" "),_c('div',{staticClass:"columns"},_vm._l((_vm.cliticFeats),function(feat){return _c('div',{key:feat,staticClass:"column is-one-fifth"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.translations.feats[feat][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[(_vm.feat4pos[_vm.pos] && _vm.feat4pos[_vm.pos][feat])?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.feats[feat].value),expression:"feats[feat].value"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.feats[feat], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.lodash.sortBy(_vm.feat4pos[_vm.pos][feat].options)),function(val){return (_vm.feat4pos[_vm.pos] && _vm.feat4pos[_vm.pos][feat])?_c('option',{key:val,domProps:{"value":val}},[_vm._v(_vm._s(_vm.translations.feats[feat].values[val][_vm.lang]))]):_vm._e()}),0):_c('select',{attrs:{"disabled":""}})])])}),0),_vm._v(" "),_c('div',{staticClass:"columns"},_vm._l((_vm.otherFeats1),function(feat){return _c('div',{key:feat,staticClass:"column is-one-fifth"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.translations.feats[feat][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[(_vm.feat4pos[_vm.pos] && _vm.feat4pos[_vm.pos][feat])?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.feats[feat].value),expression:"feats[feat].value"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.feats[feat], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.feat4pos[_vm.pos][feat].required)?_c('option',{attrs:{"value":"*"}},[_vm._v("Default")]):_vm._e(),_vm._v(" "),(!_vm.feat4pos[_vm.pos][feat].required)?_c('option',{attrs:{"value":"ANY"}},[_vm._v("Any")]):_vm._e(),_vm._v(" "),_vm._l((_vm.feat4pos[_vm.pos][feat].options),function(val){return (_vm.feat4pos[_vm.pos] && _vm.feat4pos[_vm.pos][feat])?_c('option',{key:val,domProps:{"value":val}},[_vm._v(_vm._s(_vm.translations.feats[feat].values[val][_vm.lang]))]):_vm._e()})],2):_c('select',{attrs:{"disabled":""}})])])}),0),_vm._v(" "),_c('div',{staticClass:"columns"},_vm._l((_vm.otherFeats2),function(feat){return _c('div',{key:feat,staticClass:"column is-one-fifth"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.translations.feats[feat][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"select is-fullwidth"},[(_vm.feat4pos[_vm.pos] && _vm.feat4pos[_vm.pos][feat])?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.feats[feat].value),expression:"feats[feat].value"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.feats[feat], "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[(!_vm.feat4pos[_vm.pos][feat].required)?_c('option',{attrs:{"value":"*"}},[_vm._v("Default")]):_vm._e(),_vm._v(" "),(!_vm.feat4pos[_vm.pos][feat].required)?_c('option',{attrs:{"value":"ANY"}},[_vm._v("Any")]):_vm._e(),_vm._v(" "),_vm._l((_vm.feat4pos[_vm.pos][feat].options),function(val){return (_vm.feat4pos[_vm.pos] && _vm.feat4pos[_vm.pos][feat])?_c('option',{key:val,domProps:{"value":val}},[_vm._v(_vm._s(_vm.translations.feats[feat].values[val][_vm.lang]))]):_vm._e()})],2):_c('select',{attrs:{"disabled":""}})])])}),0),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-fifth is-flex"},[_c('a',{staticClass:"button is-primary is-fullwidth align-bottom",on:{"click":_vm.reinflect}},[_vm._v("Reinflect")])])])])]),_vm._v(" "),(_vm.showError)?_c('div',{staticClass:"error-box has-text-danger is-size-5"},[_c('p'),_c('div',{staticClass:"fa fa-times"}),_vm._v(" "+_vm._s(_vm.errorMsg)),_c('p')]):_vm._e(),_vm._v(" "),(_vm.output !== null)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.output !== null)?_c('div',{attrs:{"id":"analyzer-output"}},[_c('label',{staticClass:"label"},[_vm._v("Output")]),_vm._v(" "),_c('div',{staticClass:"output-control"},[(!_vm.rawView)?_c('a',{staticClass:"has-text-primary",on:{"click":function($event){return _vm.setRawView(true)}}},[_vm._v("Show Feature-Value Pairs")]):_vm._e(),_vm._v(" "),(_vm.rawView)?_c('a',{staticClass:"has-text-primary",on:{"click":function($event){return _vm.setRawView(false)}}},[_vm._v("Show Simplified Analyses")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box analysis-wrapper"},[_c('analyzer-output',{attrs:{"lang":_vm.lang,"outputData":_vm.output,"rawView":_vm.rawView}})],1)]):_vm._e(),_vm._v(" "),_vm._m(1)])}
var Reinflector_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification is-primary"},[_c('p',[_c('strong',[_vm._v("CALIMA Star")]),_vm._v(" is an Arabic morphological analyzer and generator.\n        Given a seed word and specifific inflectional features, the reinflector mode generates new words and their corresponding analyses.\n        This demo is based on the work described in Taji et al. (2018). "),_c('sup',[_vm._v("[1]")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bibliography"},[_c('p',[_vm._v("[1]\n      "),_c('a',{attrs:{"href":"/static/CalimaStar.pdf","target":"_blank"}},[_vm._v("\n        Dima Taji, Salam Khalifa, Ossama Obeid, Fadhl Eryani and Nizar Habash.\n        "),_c('strong',[_vm._v("An Arabic Morphological Analyzer and Generator with Copious Features.")]),_vm._v(" "),_c('i',[_vm._v("Workshop on Computational Research in Phonetics, Phonology, and Morphology.\n        The Confernece on Empirical Methods in Natural Language Processing (EMNLP 2018), Brussels, Belgium.")])])])])}]
var Reinflector_esExports = { render: Reinflector_render, staticRenderFns: Reinflector_staticRenderFns }
/* harmony default export */ var components_Reinflector = (Reinflector_esExports);
// CONCATENATED MODULE: ./src/components/Reinflector.vue
function Reinflector_injectStyle (ssrContext) {
  __webpack_require__("/lGl")
}
var Reinflector_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Reinflector___vue_template_functional__ = false
/* styles */
var Reinflector___vue_styles__ = Reinflector_injectStyle
/* scopeId */
var Reinflector___vue_scopeId__ = "data-v-0d3b8be6"
/* moduleIdentifier (server only) */
var Reinflector___vue_module_identifier__ = null
var Reinflector_Component = Reinflector_normalizeComponent(
  Reinflector,
  components_Reinflector,
  Reinflector___vue_template_functional__,
  Reinflector___vue_styles__,
  Reinflector___vue_scopeId__,
  Reinflector___vue_module_identifier__
)

/* harmony default export */ var src_components_Reinflector = (Reinflector_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: {
      name: 'Analyzer'
    }
  }, {
    path: '/analyzer',
    name: 'Analyzer',
    component: src_components_Analyzer
  }, {
    path: '/generator',
    name: 'Generator',
    component: src_components_Generator
  }, {
    path: '/reinflector',
    name: 'Reinflector',
    component: src_components_Reinflector
  }]
});

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__webpack_require__("JD12");

Object.defineProperty(vue_esm["a" /* default */].prototype, '$lodash', { value: lodash_default.a });

vue_esm["a" /* default */].config.productionTip = false;
vue_esm["a" /* default */].use(vue_resource_esm["a" /* default */]);

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "THkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translations_json__ = __webpack_require__("eBIA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__translations_json__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// eslint-disable-next-line



var prcFeats = ['prc3', 'prc2', 'prc1', 'prc0'];
var tokFeats = {
  atbtok: 1,
  atbseg: 1,
  d1tok: 1,
  d1seg: 1,
  d2tok: 1,
  d2seg: 1,
  d3tok: 1,
  d3seg: 1
};
var ltrFeats = {
  prc0: 1,
  prc1: 1,
  prc2: 1,
  prc3: 1,
  enc0: 1,
  enc1: 1,
  enc2: 1,
  enc3: 1,
  gloss: 1,
  caphi: 1,
  pos: 1,
  asp: 1,
  vox: 1,
  mod: 1,
  gen: 1,
  per: 1,
  num: 1,
  stt: 1,
  cas: 1,
  rat: 1,
  source: 1,
  stemcat: 1,
  bw: 1,
  pattern: 1
};

// eslint-disable-next-line
var encFeats = ['enc0'];

function parseClitics(analysis) {
  var result = {
    enc: [],
    prc: []
  };

  var d3tok = analysis.d3tok || '';
  var d3subtoks = d3tok.split('_');
  var prcLex = d3subtoks.filter(function (t) {
    return t[t.length - 1] === '+';
  });
  var prcPOS = [];
  var encLex = d3subtoks.filter(function (t) {
    return t[0] === '+';
  });
  var encPOS = [];

  for (var p = 0; p < prcFeats.length; p += 1) {
    var featVal = analysis[prcFeats[p]] || '';
    if (featVal !== '0') {
      var subtoks = featVal.split('_');
      prcPOS.push(subtoks[1]);
    }
  }

  result.prc = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.zipWith(prcLex, prcPOS, function (lex, pos) {
    return { lex: lex, pos: pos };
  });

  for (var e = 0; e < encFeats.length; e += 1) {
    var _featVal = analysis[encFeats[e]] || '';
    if (_featVal !== '0') {
      encPOS.push(_featVal);
    }
  }

  result.enc = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.zipWith(encLex, encPOS, function (lex, pos) {
    return { lex: lex, pos: pos };
  });

  return result;
}

function scoreLemma(lemma) {
  var result = {
    sources: {
      lex: 0.0,
      spvar: 0.0,
      digit: 0.0,
      punc: 0.0,
      foreign: 0.0
    },
    lexLen: 0
  };

  if (lemma.raw.length === 0) {
    return result;
  }

  var lexStripped = lemma.raw[0].lex.split(/_|-/)[0];
  result.lexLen = lexStripped.length;

  for (var i = 0; i < lemma.raw.length; i += 1) {
    var lemmaSource = lemma.raw[i].source || null;
    if (lemmaSource === 'lex' || lemmaSource === 'spvar' || lemmaSource === 'digit' || lemmaSource === 'punc' || lemmaSource === 'foreign') {
      result.sources[lemmaSource] += 1;
    }
  }

  var sourceTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result.sources);
  for (var _i = 0; _i < sourceTypes.length; _i += 1) {
    result.sources[sourceTypes[_i]] /= lemma.raw.length;
  }

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AnalyzerOutput',
  components: {},
  props: {
    outputData: {
      type: Object,
      default: function _default() {
        return { words: [] };
      }
    },
    lang: {
      type: String,
      default: function _default() {
        return 'en';
      }
    },
    rawView: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      numeral: __WEBPACK_IMPORTED_MODULE_2_numeral___default.a,
      tokFeats: tokFeats,
      ltrFeats: ltrFeats,
      featOrder: ['diac', 'caphi', 'lex', 'bw', 'gloss', 'pos', 'prc3', 'prc2', 'prc1', 'prc0', 'enc0', 'asp', 'vox', 'mod', 'gen', 'num', 'stt', 'cas', 'per', 'rat', 'source', 'stem', 'stemcat', 'd3tok', 'd3seg', 'd2tok', 'd2seg', 'd1tok', 'd1seg', 'atbtok', 'atbseg']
    };
  },


  computed: {
    sortedTranslatedOutput: function sortedTranslatedOutput() {
      var _this = this;

      var result = {
        words: [],
        ambiguity: {
          lemmas: 1,
          analyses: 1
        }
      };

      var _loop = function _loop(w) {
        var word = _this.outputData.words[w].word;
        var analyses = _this.outputData.words[w].analyses || [];
        var lemmas = {};

        analyses.sort(function (a, b) {
          if (a.source === 'lex' && b.source !== 'lex') return -1;
          if (a.source !== 'lex' && b.source === 'lex') return 1;

          var aBw = a.bw || '';
          var bBw = b.bw || '';

          if (aBw > bBw) return 1;
          if (aBw < bBw) return -1;

          return 0;
        });

        for (var a = 0; a < analyses.length; a += 1) {
          var analysis = analyses[a];
          var lemma = analysis.lex.split(/_|-/)[0];
          var pos = analysis.pos;
          var root = analysis.root === 'ٌطWص' ? '-' : analysis.root || 'N/A';
          var stemgloss = analysis.stemgloss ? analysis.stemgloss : analysis.gloss;
          stemgloss = stemgloss === 'NO_ANALYSIS' ? 'N/A' : stemgloss;
          // const lemmaPOS = `${lemma} \u2014 ${pos} \u2014 [${root}] \u2014 ${stemgloss}`;
          var lemmaPOS = lemma + ' \u2014 ' + pos + ' \u2014 [' + root + ']';
          var translated = {
            diac: analysis.diac,
            caphi: analysis.caphi,
            root: analysis.root,
            stemgloss: stemgloss,
            morphoFeat: '',
            prc: [],
            enc: [],
            source: analysis.source
          };

          // TODO: Remove this. This is just a quick fix until db is fixed.
          if (analysis.rat === 'b') {
            analysis.rat = 'i';
          } else if (analysis.rat === 'y') {
            analysis.rat = 'na';
          }

          var order = _this.lang === 'ar' ? __WEBPACK_IMPORTED_MODULE_3__translations_json__["translations"].pos[pos].featsAR : __WEBPACK_IMPORTED_MODULE_3__translations_json__["translations"].pos[pos].featsEN;
          if (__WEBPACK_IMPORTED_MODULE_3__translations_json__["translations"].pos[pos]) {
            var morphoFeats = [];
            for (var f = 0; f < order.length; f += 1) {
              var feat = order[f];
              var featVal = analysis[feat] === 'u' || analysis[feat] === 'na' || analysis[feat] === '-' || analysis[feat] === null ? '' : __WEBPACK_IMPORTED_MODULE_3__translations_json__["translations"].feats[feat].values[analysis[feat]][_this.lang] || '';

              morphoFeats.push(featVal);
            }
            translated.morphoFeat = morphoFeats.join(' ').trim();
          }

          var clitics = parseClitics(analysis);

          translated.prc = clitics.prc;
          translated.enc = clitics.enc;

          if (Object.hasOwnProperty.call(lemmas, lemmaPOS)) {
            var glosses = analysis.stemgloss.split(/;/);
            for (var g = 0; g < glosses.length; g += 1) {
              lemmas[lemmaPOS].glosses[glosses[g]] = 1;
            }
            lemmas[lemmaPOS].raw.push(analysis);
            lemmas[lemmaPOS].translated.push(translated);
          } else {
            lemmas[lemmaPOS] = {};
            lemmas[lemmaPOS].glosses = {};
            var _glosses = analysis.stemgloss.split(/;/);
            for (var i = 0; i < _glosses.length; i += 1) {
              lemmas[lemmaPOS].glosses[_glosses[i]] = 1;
            }
            lemmas[lemmaPOS].raw = [analysis];
            lemmas[lemmaPOS].translated = [translated];
          }
        }

        // Concatenate unique glosses as a single string
        var lemmaPOSs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(lemmas);
        for (var lemmaNdx = 0; lemmaNdx < lemmaPOSs.length; lemmaNdx += 1) {
          var _lemmaPOS = lemmaPOSs[lemmaNdx];
          var uniqueGlosses = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(lemmas[_lemmaPOS].glosses));
          uniqueGlosses.sort();
          var glossString = uniqueGlosses.join(';');
          lemmas[_lemmaPOS].glossString = glossString;
        }

        var ambiguity = {
          lemmas: Math.max(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(lemmas).length, 1),
          analyses: Math.max(analyses.length, 1)
        };

        // Sort lemmas by relevance score
        var lemmaScores = {};
        var lemmaKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(lemmas);

        for (var _i2 = 0; _i2 < lemmaKeys.length; _i2 += 1) {
          var lemmaKey = lemmaKeys[_i2];
          var lemmaScore = scoreLemma(lemmas[lemmaKey]);
          lemmaScores[lemmaKey] = lemmaScore;
        }

        lemmaKeys.sort(function (a, b) {
          if (lemmaScores[a].sources.lex > lemmaScores[b].sources.lex) return -1;
          if (lemmaScores[a].sources.lex < lemmaScores[b].sources.lex) return 1;
          if (lemmaScores[a].sources.spvar > lemmaScores[b].sources.spvar) return -1;
          if (lemmaScores[a].sources.spvar < lemmaScores[b].sources.spvar) return 1;
          if (lemmaScores[a].sources.digit > lemmaScores[b].sources.digit) return -1;
          if (lemmaScores[a].sources.digit < lemmaScores[b].sources.digit) return 1;
          if (lemmaScores[a].sources.punc > lemmaScores[b].sources.punc) return -1;
          if (lemmaScores[a].sources.punc < lemmaScores[b].sources.punc) return 1;
          if (lemmaScores[a].sources.foreign > lemmaScores[b].sources.foreign) return -1;
          if (lemmaScores[a].sources.foreign < lemmaScores[b].sources.foreign) return 1;
          if (lemmaScores[a].lexLen > lemmaScores[b].lexLen) return -1;
          if (lemmaScores[a].lexLen < lemmaScores[b].lexLen) return 1;
          return 0;
        });

        result.words.push({
          word: word,
          lemmas: lemmas,
          sortedLemmas: lemmaKeys,
          ambiguity: ambiguity
        });

        result.ambiguity.lemmas *= ambiguity.lemmas;
        result.ambiguity.analyses *= ambiguity.analyses;
      };

      for (var w = 0; w < this.outputData.words.length; w += 1) {
        _loop(w);
      }

      return result;
    }
  },

  methods: {
    ambigFormat: function ambigFormat(n) {
      if (n === Infinity || n === undefined || isNaN(n)) {
        return n;
      }

      return n < 10000 ? __WEBPACK_IMPORTED_MODULE_2_numeral___default()(n).format('0,0') : __WEBPACK_IMPORTED_MODULE_2_numeral___default()(n).format('0,0.000e+0');
    },
    parseToks: function parseToks(s) {
      var result = {
        prefixes: [],
        stems: [],
        suffixes: []
      };

      var toks = s.split('_');

      for (var t = 0; t < toks.length; t += 1) {
        var token = toks[t];

        if (token.startsWith('+')) {
          result.suffixes.push(token.substring(1));
        } else if (token.endsWith('+')) {
          result.prefixes.push(token.substring(0, token.length - 1));
        } else {
          result.stems.push(token);
        }
      }

      return result;
    }
  },

  watch: {},

  mounted: function mounted() {
    // eslint-disable-next-line
    $('.collapse-btn').click(function () {
      var body = $(this).parent('.collapse-header').parent('.collapsible').children('.collapse-body');
      if (body.hasClass('collapsed')) {
        body.removeClass('collapsed');
        $(this).removeClass('collapsed');
      } else {
        body.addClass('collapsed');
        $(this).addClass('collapsed');
      }
      return 0;
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eBIA":
/***/ (function(module, exports) {

module.exports = {"translations":{"pos":{"*":{"en":"Any","ar":"Any","featsEN":["gen","num","stt","cas","rat","per","mod","asp","vox"],"featsAR":["gen","num","stt","cas","rat","per","mod","asp","vox"]},"noun":{"en":"Noun","ar":"اسم","featsEN":["gen","num","stt","cas","rat"],"featsAR":["gen","num","stt","cas","rat"]},"part_neg":{"en":"Negative Particle","ar":"أداة نفي","featsEN":[],"featsAR":[]},"pron_rel":{"en":"Relative Pronoun","ar":"ضمير موصول","featsEN":["gen","num"],"featsAR":["gen","num"]},"noun_num":{"en":"Number Noun","ar":"اسم عدد","featsEN":["gen","num","stt","cas","rat"],"featsAR":["gen","num","stt","cas","rat"]},"adv_interrog":{"en":"Interrogative Adverb","ar":"ظرف استفهام","featsEN":[],"featsAR":[]},"part_voc":{"en":"Vocalized Particle","ar":"حرف نداء","featsEN":[],"featsAR":[]},"adj_comp":{"en":"Comparative Adjective","ar":"صفة مقارنة","featsEN":["gen","num","stt","cas"],"featsAR":["gen","num","stt","cas"]},"punc":{"en":"Punctuation","ar":"علامة ترقيم","featsEN":[],"featsAR":[]},"conj_sub":{"en":"Subordinating Conjunction","ar":"أداة ربط","featsEN":[],"featsAR":[]},"part_fut":{"en":"Future Particle","ar":"أداة استقبال","featsEN":[],"featsAR":[]},"pron_exclam":{"en":"Pronoun Exclamation","ar":"ضمير تعجب","featsEN":[],"featsAR":[]},"part":{"en":"Particle","ar":"أداة","featsEN":[],"featsAR":[]},"part_verb":{"en":"Verbal Particle","ar":"أداة فعل","featsEN":[],"featsAR":[]},"verb":{"en":"Verb","ar":"فعل","featsEN":["gen","num","per","mod","asp","vox"],"featsAR":["gen","num","per","mod","asp","vox"]},"digit":{"en":"Digit","ar":"رقم","featsEN":[],"featsAR":[]},"conj":{"en":"Conjunction","ar":"حرف عطف","featsEN":[],"featsAR":[]},"pron_interrog":{"en":"Interrogative Pronoun","ar":"ضمير استفهام","featsEN":[],"featsAR":[]},"pron":{"en":"Pronoun","ar":"ضمير","featsEN":["gen","num","per"]},"abbrev":{"en":"Abbreviation","ar":"اختصار","featsEN":[],"featsAR":[]},"part_det":{"en":"Determiner Particle","ar":"أداة تعريف","featsEN":[],"featsAR":[]},"interj":{"en":"Interjection","ar":"تعجب","featsEN":[],"featsAR":[]},"adj_num":{"en":"Numerical Adjective","ar":"صفة عدد","featsEN":["gen","num","stt","cas"],"featsAR":["gen","num","stt","cas"]},"adv":{"en":"Adverb","ar":"ظرف","featsEN":[],"featsAR":[]},"part_restrict":{"en":"Restrictive Particle","ar":"أداة استثناء","featsEN":[],"featsAR":[]},"adv_rel":{"en":"Relative Adverb","ar":"ظرف موصول","featsEN":[],"featsAR":[]},"adj":{"en":"Adjective","ar":"صفة","featsEN":["gen","num","stt","cas"],"featsAR":["gen","num","stt","cas"]},"prep":{"en":"Preposition","ar":"حرف جر","featsEN":[],"featsAR":[]},"part_interrog":{"en":"Interrogative Particle","ar":"أداة استفهام","featsEN":[],"featsAR":[]},"verb_pseudo":{"en":"Pseudo Verb","ar":"شبه فعل","featsEN":[],"featsAR":[]},"noun_prop":{"en":"Proper Noun","ar":"اسم علم","featsEN":["gen","num","stt","cas","rat"],"featsAR":["gen","num","stt","cas","rat"]},"part_focus":{"en":"Focus Particle","ar":"أداة توكيد","featsEN":[],"featsAR":[]},"noun_quant":{"en":"Quantity Noun","ar":"اسم كم","featsEN":["gen","num","stt","cas","rat"],"featsAR":["gen","num","stt","cas","rat"]},"latin":{"en":"Foreign","ar":"أجنبي","featsEN":[],"featsAR":[]},"foreign":{"en":"Foreign","ar":"أجنبي","featsEN":[],"featsAR":[]},"pron_dem":{"en":"Demonstrative Pronoun","ar":"ضمير إشارة","featsEN":["gen","num"],"featsAR":["gen","num"]}},"feats":{"prc1":{"en":"Prepositions","ar":"سابقة 1","values":{"0":{"en":"None","ar":"تجاهل"},"la_emph":{"en":"لَ/EMPH","ar":"أداة توكيد"},"ka_prep":{"en":"كَ/PREP","ar":"حرف جر"},"fiy_prep":{"en":"فِي/PREP","ar":"حرف جر"},"li_jus":{"en":"لِ/JUS","ar":"حرف جازم"},"la_rc":{"en":"لَ/RC","ar":"جواب شرط"},"li_prep":{"en":"لِ/PREP","ar":"حرف جر"},"wA_voc":{"en":"وا/VOC","ar":"حرف نداء"},"yA_voc":{"en":"يا/VOC","ar":"حرف نداء"},"ta_prep":{"en":"تَ/PREP","ar":"حرف جر"},"wa_prep":{"en":"وَ/PREP","ar":"حرف جر"},"sa_fut":{"en":"سَ/FUT","ar":"سين الاستقبال"},"hA_dem":{"en":"ها/DEM","ar":"أداة تنبيه"},"bi_prep":{"en":"بِ/PREP","ar":"حرف جر"},"la_prep":{"en":"لَ/PREP","ar":""},"bi_part":{"en":"بِ/PART","ar":"حرف"}}},"vox":{"en":"Voice","ar":"البناء","values":{"p":{"en":"Passive","ar":"للمجهول"},"u":{"en":"Undefined","ar":"غير معرف"},"a":{"en":"Active","ar":"للمعلوم"}}},"num":{"en":"Number","ar":"العدد","values":{"s":{"en":"Singular","ar":"مفرد"},"d":{"en":"Dual","ar":"مثنى"},"u":{"en":"Undefined","ar":"غير معرف"},"p":{"en":"Plural","ar":"جمع"}}},"stt":{"en":"State","ar":"التعريف","values":{"u":{"en":"Undefined","ar":"غير معرف"},"i":{"en":"Indefinite","ar":"نكرة"},"c":{"en":"Construct","ar":"مضاف"},"d":{"en":"Definite","ar":"معرفة"}}},"cas":{"en":"Case","ar":"الإعراب","values":{"u":{"en":"Undefined","ar":"غير معرف"},"n":{"en":"Nominative","ar":"مرفوع"},"a":{"en":"Accusative","ar":"منصوب"},"g":{"en":"Genitive","ar":"مجرور"}}},"prc3":{"en":"Question","ar":"سابقة 3","values":{"0":{"en":"None","ar":"تجاهل"},">a_ques":{"en":"أَ/QUES","ar":"أداة استفهام"}}},"prc2":{"en":"Conjunctions","ar":"سابقة 2","values":{"0":{"en":"None","ar":"تجاهل"},"fa_conn":{"en":"فَ/CONN","ar":"حرف ربط"},"fa_rc":{"en":"فَ/RC","ar":"جواب شرط"},"wa_part":{"en":"وَ/PART","ar":"حرف"},"wa_sub":{"en":"وَ/SUB","ar":"أداة ربط"},"fa_sub":{"en":"فَ/SUB","ar":"أداة ربط"},"wa_conj":{"en":"وَ/CONJ","ar":"حرف عطف"},"fa_conj":{"en":"فَ/CONJ","ar":"حرف عطف"}}},"gen":{"en":"Gender","ar":"الجنس","values":{"m":{"en":"Masculine","ar":"مذكر"},"f":{"en":"Feminine","ar":"مؤنث"},"u":{"en":"Undefined","ar":"غير معروف"}}},"prc0":{"en":"Articles","ar":"سابقة 0","values":{"0":{"en":"None","ar":"تجاهل"},"mA_part":{"en":"ما/PART","ar":"حرف"},"Al_det":{"en":"ال/DET","ar":"ال التعريف"},"mA_neg":{"en":"ما/NEG","ar":"أداة نفي"},"lA_neg":{"en":"لا/NEG","ar":"أداة نفي"},"mA_rel":{"en":"ما/REL","ar":"ضمير موصول"}}},"asp":{"en":"Aspect","ar":"الزمن","values":{"p":{"en":"Perfective","ar":"ماضي"},"c":{"en":"Command","ar":"أمر"},"i":{"en":"Imperfective","ar":"مضارع"}}},"per":{"en":"Person","ar":"الشخص","values":{"1":{"en":"1st","ar":"متكلم"},"2":{"en":"2nd","ar":"مخاطب"},"3":{"en":"3rd","ar":"غائب"}}},"rat":{"en":"Rationality","ar":"صفة العقل","values":{"r":{"en":"Rational","ar":"عاقل"},"i":{"en":"Irrational","ar":"غير عاقل"},"n":{"en":"","ar":""}}},"pos":{"en":"Part-of-Speech","ar":"قسم الكلام","values":{}},"lex":{"en":"Lemma","ar":"الدخل المعجمي","values":{}},"mod":{"en":"Mood","ar":"الإعراب","values":{"s":{"en":"Subjunctive","ar":"منصوب"},"i":{"en":"Indicative","ar":"مرفوع"},"u":{"en":"Undefined","ar":"غير معرف"},"j":{"en":"Jussive","ar":"مجزوم"}}},"enc0":{"en":"Pronominals","ar":"لاحقة 0","values":{"0":{"en":"None","ar":"تجاهل"},"3mp_poss":{"en":"هم/PRON.3MP","ar":"ضمير ملكية جمع مذكر للغائب"},"3d_dobj":{"en":"هما/PRON.3D","ar":"ضمير مفعول به مباشر مثنى للغائب"},"2mp_poss":{"en":"كم/PRON.2MP","ar":"ضمير ملكية جمع مذكر للمخاطب"},"3d_pron":{"en":"هما/PRON.3D","ar":"ضمير مثنى للغائب"},"3ms_pron":{"en":"ه/PRON.3MS","ar":"ضمير مفرد مذكر للغائب"},"3ms_poss":{"en":"ه/PRON.3MS","ar":"ضمير ملكية مفرد مذكر للغائب"},"man_interrog":{"en":"مَن/PRON_INTERROG","ar":"ضمير استفهام"},"3mp_pron":{"en":"هم/PRON.3MP","ar":"ضمير جمع  مذكر للغائب"},"2d_pron":{"en":"كما/PRON.2D","ar":"ضمير مثنى للمخاطب"},"3mp_dobj":{"en":"هم/PRON.3MP","ar":"ضمير مفعول به مباشر جمع مذكر للغائب"},"2fp_pron":{"en":"كن/PRON.2FP","ar":"ضمير جمع مؤنث للمخاطب"},"lA_neg":{"en":"لا/PART_NEG","ar":"أداة نفي"},"man_rel":{"en":"مَن/PRON_REL","ar":"ضمير موصول"},"1s_dobj":{"en":"ني/PRON.1S","ar":"ضمير مفعول به مباشر مفرد للمتكلم"},"2ms_pron":{"en":"ك/PRON.2MS","ar":"ضمير مفرد مذكر للمخاطب"},"2mp_pron":{"en":"كم/PRON.2MP","ar":"ضمير جمع مذكر للمخاطب"},"ma_interrog":{"en":"مَ/PRON_INTERROG","ar":"ضمير استفهام"},"3fs_dobj":{"en":"ها/PRON.3FS","ar":"ضمير مفعول به مباشر مفرد مؤنث للغائب"},"mA_rel":{"en":"ما/PRON_REL","ar":"ضمير موصول"},"2fs_pron":{"en":"كِ/PRON.2FS","ar":"ضمير مفرد مؤنث للمخاطب"},"2fp_poss":{"en":"كن/PRON.2FP","ar":"ضمير ملكية جمع مؤنث للمخاطب"},"1s_poss":{"en":"ي/PRON.1S","ar":"ضمير ملكية مفرد للمتكلم"},"Ah_voc":{"en":"اه/PART_VOC","ar":"أداة نداء"},"2d_dobj":{"en":"كما/PRON.2D","ar":"ضمير مفعول به مباشر مثنى للمخاطب"},"2mp_dobj":{"en":"كم/PRON.2MP","ar":"ضمير مفعول به مباشر جمع مذكر للمخاطب"},"3fp_pron":{"en":"هن/PRON.3FP","ar":"ضمير جمع مؤنث للغائب"},"1p_poss":{"en":"نا/PRON.1P","ar":"ضمير ملكية جمع للمتكلم"},"ma_rel":{"en":"مَ/PRON_REL","ar":"ضمير موصول"},"2fs_poss":{"en":"كِ/PRON.2FS","ar":"ضمير ملكية مفرد مؤنث للمخاطب"},"3ms_dobj":{"en":"ه/PRON.3MS","ar":"ضمير مفعول به مباشر مفرد مذكر للغائب"},"mA_interrog":{"en":"ما/PRON_INTERROG","ar":"ضمير استفهام"},"3d_poss":{"en":"هما/PRON.3D","ar":"ضمير ملكية مثنى للغائب"},"3fp_poss":{"en":"هن/PRON.3FP","ar":"ضمير ملكية جمع مؤنث للغائب"},"ma_sub":{"en":"ما/CONJ_SUB","ar":"أداة ربط"},"2fp_dobj":{"en":"كن/PRON.2FP","ar":"ضمير مفعول به مباشر جمع مؤنث للمخاطب"},"2d_poss":{"en":"كما/PRON.2D","ar":"ضمير ملكية مثنى للمخاطب"},"1s_pron":{"en":"ي/PRON.1S","ar":"ضمير مفرد للمتكلم"},"3fs_pron":{"en":"ها/PRON.3FS","ar":"ضمير مفرد مؤنث للغائب"},"3fs_poss":{"en":"ها/PRON.3FS","ar":"ضمير ملكية مفرد مؤنث للغائب"},"3fp_dobj":{"en":"هن/PRON.3FP","ar":"ضمير مفعول به مباشر جمع مؤنث للغائب"},"1p_pron":{"en":"نا/PRON.1P","ar":"ضمير جمع للمتكلم"},"2fs_dobj":{"en":"كِ/PRON.2FS","ar":"ضمير مفعول به مباشر مفرد مؤنث للمخاطب"},"2ms_poss":{"en":"ك/PRON.2MS","ar":"ضمير ملكية مفرد مذكر للمخاطب"},"1p_dobj":{"en":"نا/PRON.1P","ar":"ضمير مفعول به مباشر جمع  للمتكلم"},"2ms_dobj":{"en":"ك/PRON.2MS","ar":"ضمير مفعول به مباشر مفرد مذكر للمخاطب"},"mA_sub":{"en":"ما/CONJ_SUB","ar":"أداة ربط"}}}}}}

/***/ }),

/***/ "p+Bj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d728a25553c961acd1b9.js